import { render, staticRenderFns } from "./ManifestList.vue?vue&type=template&id=8850a162"
import script from "./ManifestList.vue?vue&type=script&lang=js"
export * from "./ManifestList.vue?vue&type=script&lang=js"
import style0 from "./ManifestList.vue?vue&type=style&index=0&id=8850a162&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports